import homeIcon from '../assets/images/journal.png';
import characterIcon from '../assets/images/person.png';
import diceIcon from '../assets/images/dice.png';
import skillsIcon from '../assets/images/dual-sabers.png';
import logoutIcon from '../assets/images/deathstar.png';

export const icons = {
  home: homeIcon,
  character: characterIcon,
  dice: diceIcon,
  skills: skillsIcon,
  logout: logoutIcon
}